<section class="coverage container flex">
	<div class="container-left flex">
		<span class="text text-title">Estamos para ayudarte</span>
		<div class="wrap-helper-text flex">
			<div class="wrap-contact flex">
				<div class="wrap-item flex">
					<img src="assets/images/ico-phone.svg" alt="icon phone" class="icon" />
					<div class="wrap-text-contact flex">
						<span class="text title-contact">Centro de servicios</span>
						<span class="text subtitle-contact">Contáctanos llamando al 226928555</span>
					</div>
				</div>
				<div class="wrap-item flex">
					<img src="assets/images/ico-mail.svg" alt="icon mail" class="icon" />
					<div class="wrap-text-contact flex">
						<span class="text title-contact">Email apoyo empresarios</span>
						<span class="text subtitle-contact">Escríbenos a apoyoempresarios&#64;bci.cl</span>
					</div>
				</div>
				<div class="wrap-item chat flex">
					<img src="assets/images/ico-chat.svg" alt="icon chat" class="icon" />
					<div class="wrap-text-contact flex">
						<span class="text title-contact">Chat en Línea</span>
						<span class="text subtitle-contact"
							>Conversa con nosotros a través del Chat en Línea de Bci Pyme.</span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container-right flex">
		<img src="assets/images/bci-logo.svg" alt="logo bci" class="logo" />
		<p class="text direccion">
			Av. El Golf 125, Las Condes, Santiago. Infórmate sobre la garantía estatal de los depósitos en tu
			banco o en
			<a class="link" (click)="onOpenLink(links.institutional.cmf)">www.cmfchile.cl</a>.
		</p>
		<p class="text">
			Infórmate sobre las entidades autorizadas para emitir Tarjetas de Pago en el país, quienes se
			encuentran inscritas en los Registros de Emisores de Tarjetas en
			<a class="link" (click)="onOpenLink(links.institutional.cmf)">www.cmfchile.cl</a>.
		</p>
	</div>
</section>
